<h5>Last Status Event</h5>
<pre *ngIf="status$ | async as status; else none"
  >{{ status | json }}
</pre>
<ng-template #none> None </ng-template>
